module.exports = __webpack_public_path__ + "static/media/pattern-1.e1a25191.png";